export const enUSExpenses = {
  pageTitle: 'Expenses',
  loading: 'Loading expenses...',
  errorLoad: 'Failed to load expenses: {{error}}',
  noExpensesTitle: 'No expenses this month',
  noExpenses: 'No expenses for {{year}}-{{month}}. Add your first expense or check a different month.',
  total: 'Total',
  monthTotal: 'Month total',
  moreActions: 'More actions',
  accountFilterLabel: 'Account',
  entriesSection: 'Income',
  paid: 'Paid',
  pending: 'Pending',
  paymentProgress: 'Payment progress',
  paymentProgressAria: 'Payment progress',
  overdueHint: 'Includes expenses that are already due and unpaid',
  addExpense: '+ Add Expense',
  addButton: 'Add',
  addExpenseItem: 'Expense',
  addDepositItem: 'Deposit',
  allAccounts: 'All Accounts',
  accountBreakdown: 'Account Breakdown',
  totalLabel: 'Total: ',
  paidPending: 'Paid: {{paid}} | Pending: {{pending}}',
  statusPaid: '\u2713 Paid',
  statusOverdue: 'Overdue',
  statusDue: 'Due Today',
  statusUpcoming: 'Upcoming',
  dateLabel: 'Date',
  dueLabel: 'Due',
  categoryLabel: 'Category',
  accountLabel: 'Account',
  recurring: 'Recurring',
  markPaid: 'Paid',
  edit: 'Edit',
  delete: 'Delete',
  formDescription: 'Description',
  formDescriptionPlaceholder: 'Enter description',
  formDescriptionSearchPlaceholder: 'Type to search descriptions...',
  formDescriptionNoResults: 'No matching descriptions',
  formAmount: 'Amount',
  formDate: 'Date',
  formDueDate: 'Due Date (Optional)',
  formMarkAsPaid: 'Mark as paid',
  formCategory: 'Category (Optional)',
  formCategoryNone: '-- None --',
  categorySelectorSearch: 'Search categories...',
  categorySelectorEmpty: 'No categories found.',
  categorySelectorSuggested: 'Suggested',
  formAccount: 'Paying Account',
  formAccountRequired: 'Paying Account *',
  formAccountSelect: '-- Select Account --',
  formNotes: 'Notes (Optional)',
  formNotesPlaceholder: 'Add a note about this expense...',
  formSaving: 'Saving...',
  formCreate: 'Create Expense',
  formUpdate: 'Update Expense',
  formError: 'An error occurred',
  modalAdd: 'Add Expense',
  modalEdit: 'Edit Expense',
  deleteTitle: 'Delete Expense',
  deleteMessage: 'Are you sure you want to delete "{{description}}"? This action cannot be undone.',
  deleteConfirm: 'Delete',
  validationAmountRequired: 'Amount is required',
  validationDescriptionRequired: 'Description is required',
  validationDescriptionTooLong: 'Description too long',
  validationDateRequired: 'Date is required',
  validationNotesTooLong: 'Notes must be at most 500 characters',
  toastCreated: 'Expense created',
  toastUpdated: 'Expense updated',
  toastDeleted: 'Expense deleted',
  toastMarkedPaid: 'Marked as paid',
  toastMarkedUnpaid: 'Marked as unpaid',
  toastCreateError: 'Failed to create expense',
  toastUpdateError: 'Failed to update expense',
  toastDeleteError: 'Failed to delete expense',
  toastMarkPaidError: 'Failed to update status',
  installmentProgress: '{{current}}/{{total}} installments',
  paidAtLabel: 'Paid on {{date}}',
  formPaidAt: 'Payment date',
  filterAll: 'All',
  filterPaid: 'Paid',
  filterUnpaid: 'Unpaid',
  noFilteredExpenses: 'No expenses match this filter',
  receipt: {
    upload: 'Attach receipt',
    preview: 'View receipt',
    delete: 'Delete receipt',
    previewTitle: 'Receipt',
    openInDrive: 'Open in Drive',
    deleteConfirmCancel: 'Cancel',
    loading: 'Uploading...',
    previewLoading: 'Loading receipt...',
    previewError: 'Failed to load receipt',
  },
  files: {
    uploadSuccess: 'File uploaded',
    uploadError: 'Failed to upload file',
    deleteSuccess: 'File removed',
    deleteError: 'Failed to remove file',
    deleteConfirmTitle: 'Remove file?',
    deleteConfirmDescription: 'The file will be permanently removed from Google Drive.',
    deleteConfirmAction: 'Remove',
    deleteConfirmCancel: 'Cancel',
    rootFolderRequired: 'Please select a root folder in Settings before uploading files',
  },
  detail: {
    amount: 'Amount',
    date: 'Date',
    dueDate: 'Due Date',
    paidAt: 'Paid On',
    category: 'Category',
    account: 'Account',
    notes: 'Notes',
    status: 'Status',
    billSummary: 'Bill Summary',
    billAmount: 'Bill Amount',
    recurrence: 'Recurrence',
    monthly: 'Monthly',
    yearly: 'Yearly',
    unlimited: 'Unlimited',
    active: 'Active',
    inactive: 'Inactive',
    installmentProgress: '{{current}} of {{total}} installments',
    relatedExpenses: 'Related Expenses',
    receipt: 'Receipt',
    files: 'Files',
    addFile: 'Add file',
    billNotes: 'Bill Notes',
    billFiles: 'Bill files',
    noBill: 'Manual expense',
    loading: 'Loading details...',
    error: 'Failed to load expense details',
    markAsPaid: 'Mark as Paid',
    markAsUnpaid: 'Mark as Unpaid',
    edit: 'Edit',
    delete: 'Delete',
    editAmount: 'Edit amount',
    saveAmount: 'Save amount',
    cancelAmount: 'Cancel',
    amountRequired: 'Enter a valid amount',
    share: 'Share',
    shareCopied: 'Details copied!',
    shareFailed: 'Could not share or copy details',
    shareTitle: 'Nomi — Expense',
    shareDescription: 'Description',
    shareAmount: 'Amount',
    shareCategory: 'Category',
    shareDate: 'Date',
    shareStatus: 'Status',
  },
  search: {
    title: 'Search Expenses',
    placeholder: 'Search by description...',
    filterCategory: 'Category',
    filterAccount: 'Account',
    filterStatus: 'Status',
    filterDateRange: 'Date range',
    filterFrom: 'From',
    filterTo: 'To',
    allCategories: 'All categories',
    allAccounts: 'All accounts',
    allStatuses: 'All',
    paidOnly: 'Paid',
    unpaidOnly: 'Unpaid',
    resultCount: '{{count}} results',
    noResults: 'No expenses match your search',
    noResultsHint: 'Try different keywords or adjust your filters',
    loading: 'Searching...',
    clearFilters: 'Clear filters',
    viewInMonth: 'View in month',
  },
  deposit: {
    sectionTitle: 'Deposits',
    addDeposit: '+ Add Deposit',
    modalAdd: 'Add Deposit',
    modalEdit: 'Edit Deposit',
    formDescription: 'Description (Optional)',
    formDescriptionPlaceholder: 'Enter description',
    formAmount: 'Amount',
    formDate: 'Date',
    formAccount: 'Account *',
    formAccountSelect: '-- Select Account --',
    formSaving: 'Saving...',
    formCreate: 'Create Deposit',
    formUpdate: 'Update Deposit',
    formError: 'An error occurred',
    deleteTitle: 'Delete Deposit',
    deleteMessage: 'Are you sure you want to delete this deposit of {{amount}}? This action cannot be undone.',
    deleteConfirm: 'Delete',
    toastCreated: 'Deposit created',
    toastUpdated: 'Deposit updated',
    toastDeleted: 'Deposit deleted',
    toastCreateError: 'Failed to create deposit',
    toastUpdateError: 'Failed to update deposit',
    toastDeleteError: 'Failed to delete deposit',
    validationAmountRequired: 'Amount is required',
    validationDateRequired: 'Date is required',
    badgeLabel: 'Deposit',
    dateLabel: 'Date',
    accountLabel: 'Account',
  },
  export: {
    button: 'Export',
    csvMonth: 'CSV (this month)',
    pdfMonth: 'PDF (this month)',
    csvYear: 'CSV (full year)',
    downloading: 'Exporting...',
    success: 'Export downloaded',
    error: 'Failed to export',
  },
} as const;
